import React from "react";
import { Link } from "react-router-dom";
import { Key } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300 mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center">
            <img src="/logo-brand-white.png" alt="DerechoLlave" className="h-14 w-auto" />
          </div>
          <p className="mt-4 text-sm text-slate-400 max-w-xs">
            Marketplace especializado en compraventa de negocios funcionando en Chile, con
            intermediación profesional y comunicación protegida.
          </p>
        </div>
        <div>
          <p className="overline text-slate-500 mb-4">Plataforma</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/marketplace" className="hover:text-white">Marketplace</Link></li>
            <li><Link to="/#como-funciona" className="hover:text-white">Cómo funciona</Link></li>
            <li><Link to="/publicar" className="hover:text-white">Publicar negocio</Link></li>
            <li><Link to="/contacto" className="hover:text-white" data-testid="footer-contact-link">Contacto</Link></li>
          </ul>
        </div>
        <div>
          <p className="overline text-slate-500 mb-4">Para ti</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/register" className="hover:text-white">Soy vendedor</Link></li>
            <li><Link to="/register" className="hover:text-white">Soy inversionista</Link></li>
            <li><Link to="/login" className="hover:text-white">Iniciar sesión</Link></li>
          </ul>
        </div>
        <div>
          <p className="overline text-slate-500 mb-4">Legal</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/terminos" className="hover:text-white" data-testid="footer-terms-link">Términos y aviso de responsabilidad</Link></li>
            <li><Link to="/privacidad" className="hover:text-white" data-testid="footer-privacy-link">Política de privacidad</Link></li>
            <li><Link to="/confidencialidad" className="hover:text-white" data-testid="footer-confidentiality-link">Confidencialidad</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 text-xs text-slate-500 flex flex-col sm:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} DerechoLlave · Marketplace de negocios funcionando en Chile</span>
          <span>Acompañamiento profesional · Confidencialidad protegida</span>
        </div>
      </div>
    </footer>
  );
}
